import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getService = async (id: string | undefined) => {
    const { data, error } = await supabase
        .from('services')
        .select(`*`)
        .eq('id', id)
        .single()

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetServiceByid(id: string | undefined) {
    return useQuery({
        queryKey: ['useGetServiceByid', id],
        queryFn: () => getService(id || ''),
        staleTime: 0,
        enabled: !!id,
    })
}
